import React from 'react';
import EdgeControllerComponentsList from '../../../shared/components/DemoEdgeControllerComponentsList/DemoEdgeControllerComponentsList';

function DemoEdgeControllerComponents({ edgeControllerId }) {
  return (
    <div className="components-tab-content" style={{ padding: 16 }}>
      <EdgeControllerComponentsList edgeControllerId={edgeControllerId} />
    </div>
  );
}

export default DemoEdgeControllerComponents;
